import React from "react";
import {connect} from 'react-redux';
import {withRouter} from 'react-router';

export const Authorization = (allowedRoles) => (WrappedComponent) => {

    let roles = allowedRoles;

    class Wrapper extends React.Component {

        isPermission = (permissions, roles) => {
            let autorizado = false;

            roles.forEach(e => {
                if (permissions.includes(e)) autorizado = true;
            });
    
            return autorizado;
        }
    
        notPermission = (auth) => {
            let history = this.props.router || this.props.history;
            (auth.loggedIn) ? history.push('/401') : history.push('/login');
            return null;
        }
    
        render() {
            const userRoles = this.props.auth.roles;
            return this.isPermission(roles, userRoles) ?
                <WrappedComponent {...this.props} /> : this.notPermission(this.props.auth);
        }
    }
    
    function mapStateToProps(state) {
        return {auth: state.auth};
    }

    return connect(mapStateToProps)(withRouter(Wrapper));
}


// WEBPACK FOOTER //
// ./src/auth/components/Authorization.js